import { gridSortDirections } from '@core/enums/grid-sort-directions';
import { ISortModel } from '@core/interfaces/ISortModel';
import { GridSortDirection } from '@mui/x-data-grid';

export default function parseSortModel(str: string): ISortModel[] {
    const [field, _sort] = str.split('+');
    let sort: GridSortDirection;
    if (_sort === gridSortDirections.asc || _sort === gridSortDirections.desc)
        sort = _sort;
    else sort = gridSortDirections.asc;
    return [{ field, sort }];
}
